var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"navbar"},[_c('hamburger',{staticClass:"hamburger-container",attrs:{"id":"hamburger-container","is-active":_vm.sidebar.opened},on:{"toggle-click":_vm.toggleSideBar}}),_c('breadcrumb',{staticClass:"breadcrumb-container",attrs:{"id":"breadcrumb-container"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }